import { PaymentStatusResult } from '@bariendo/lib/payment-status';
import dayjs from 'dayjs';
import { MRT_ColumnDef, MRT_RowData } from 'mantine-react-table';
import { PaymentStatusBadge } from '@/components/PaymentStatusBadge';
import { QUEUE_EMPTY_COLOR, TwoLineCell } from '../../components/QueueCells';

interface FinancingRowLike extends MRT_RowData {
  paymentStatus?: PaymentStatusResult;
}

const PAYMENT_STATUS_SIZE = 140;

/** The payment status badge, then the date it moved there (BAR-3084). One colour per status, whatever its age. */
export function paymentStatusColumn<Row extends FinancingRowLike>(): MRT_ColumnDef<Row> {
  return {
    id: 'paymentStatus',
    header: 'Status',
    size: PAYMENT_STATUS_SIZE,
    accessorFn: (row) => row?.paymentStatus?.at ?? '',
    sortingFn: 'datetime',
    Cell: ({ row }) => {
      const status = row.original?.paymentStatus;
      if (!status) {
        return <TwoLineCell primary={<span style={{ color: QUEUE_EMPTY_COLOR }}>—</span>} />;
      }
      return (
        <TwoLineCell
          primary={<PaymentStatusBadge status={status.status} />}
          secondary={dayjs(status.at).format('MMM D')}
        />
      );
    },
  };
}
